'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const CustomerTypeDialog = dynamic(
  () => import('./CustomerTypeDialog').then((m) => ({ default: m.CustomerTypeDialog })),
  { ssr: false }
);

// Exit-intent-popupen är 302 rader och låg tidigare direkt i rot-layouten,
// alltså i förstahandsbunten på varje sida.
//
// OBS: enbart `dynamic(..., { ssr: false })` räcker INTE. Chunken hämtas ändå
// direkt vid hydrering, så första försöket 2026-09-07 gav 38 -> 39 JS-filer och
// ingen mätbar vinst alls. Komponenten måste också MONTERAS senare — det är
// först då importen körs.
//
// Åtta sekunder: popupen kan tidigast visa sig efter 45 s på mobil (plus 600 px
// scroll och en sekunds stillastående), och en desktopbesökare som lämnar inom
// åtta sekunder vinner man inte tillbaka med en ruta. Besökare som lämnar
// snabbare hämtar därmed aldrig koden.
const ExitIntentPopup = dynamic(
  () => import('./ExitIntentPopup').then((m) => ({ default: m.ExitIntentPopup })),
  { ssr: false }
);

// PushBanner togs bort 2026-09-03. Den var 231 px hög med z-[99] och visades
// för varje ny besökare som scrollat 200 px, på varje sida — och gav sex
// prenumeranter på 90 dagar. Push kan fortfarande slås på av kunden själv från
// /konto och från företagsportalen; det som försvann är avbrottet, inte kanalen.
// De 86 befintliga prenumerationerna och adminverktyget för utskick är orörda.

export function LazyOverlays() {
  const [showExitIntent, setShowExitIntent] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setShowExitIntent(true), 8000);
    return () => clearTimeout(id);
  }, []);

  return (
    <>
      <CustomerTypeDialog />
      {showExitIntent && <ExitIntentPopup />}
    </>
  );
}
